// export const basePath = "http://localhost:3002"
// export const basePath = "http://localhost:3100"
// export const basePath="http://143.110.190.50:3882"
export const basePath = "https://atsapi.abstarthr.in"
// export const basePath = "http://atsapi.abstarthr.in"
// export const basePath = "http://atsnewapi.abstarthr.in"

export const getCurrentDate = () => {
    return `${new Date().toISOString()?.split("T")[0]}T${new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}`;
}
// get current date and time
export const currentDateAndTime = (isT) => {
    const timeZone = 'Asia/Kolkata';

    const now = new Date();

    // Get date in YYYY-MM-DD format
    const date = new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(now); // 'YYYY-MM-DD'

    // Get time in HH:mm:ss format (24-hour)
    const time = new Intl.DateTimeFormat('en-GB', {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    }).format(now); // 'HH:mm:ss'

    return isT === 'T' ? `${date}T${time}` : `${date} ${time}`;
}
export const formatDateAndTime = (dateTimeString, format12Hour) => {
    const date = new Date(dateTimeString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    if (format12Hour === 12) {
        const ampm = hours >= 12 ? 'PM' : 'AM';
        // Convert hours from 24-hour to 12-hour format
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = String(hours).padStart(2, '0');
        return `${day}-${monthData[parseInt(month)]}-${year}T${hours}:${minutes} ${ampm}`;
    } else {
        hours = String(hours).padStart(2, '0');
        return `${day}-${monthData[parseInt(month)]}-${year}T${hours}:${minutes}`;
    }
};

const formatValidDate = (date) => {
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day.toString().padStart(2, '0')}-${month}-${year}`;
};

export const formatDateOnly = (GettedDate) => {
  if (!GettedDate) {
    return ``;
  }

  if (GettedDate instanceof Date && !isNaN(GettedDate.getTime())) {
    return formatValidDate(GettedDate);
  }

  let date;

  if (typeof GettedDate === "string" && GettedDate.includes(" ")) {
    GettedDate = GettedDate.split(" ")[0]; 
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(GettedDate)) {
    date = new Date(GettedDate);
  } 

  else if (/^\d{2}-\d{2}-\d{4}$/.test(GettedDate)) {
    const [day, month, year] = GettedDate.split("-").map(Number);
    date = new Date(`${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`);
  }

  if (date instanceof Date && !isNaN(date.getTime())) {
    return formatValidDate(date);
  }

  return ``; 
};

export const formatDateTime = (input_datetime) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Split the input_datetime into date and time parts
  const [datePart, timePart] = input_datetime?.split(" ");
  const [year, month, day] = datePart?.split("-");
  
  
  if(timePart){
        const [hours, minutes] = timePart?.split(":");
        // Convert 24-hour time to 12-hour time
        const hour = parseInt(hours, 10);
        const amPm = hour >= 12 ? "PM" : "AM";
        const formattedHour = hour % 12 || 12; // Convert 0 to 12 for midnight

        // Return the formatted string
        return `${day}-${months[parseInt(month, 10) - 1]}-${year} ${String(formattedHour).padStart(2, '0')}:${minutes} ${amPm}`;

    }else{
        // Return the formatted string
        return `${day}-${months[parseInt(month, 10) - 1]}-${year}`;
    }
 
}

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    hours = String(hours).padStart(2, '0');
    return `${day} ${monthData[parseInt(month)]} ${year}`;

};
export const daysDifference = (dateString) => {
   let days_delayed = 0;
   const nextFollowUp = dateString ? new Date(dateString) : null;
    if (nextFollowUp) {
        const today = new Date();
        const diffTime = today.getTime() - nextFollowUp.getTime();
        days_delayed = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // days difference
        return days_delayed;
    }else{
         return false;
    }
};

export const getFriendlyDate = (dateStr)=> {
  const inputDate = new Date(dateStr);
  const today = new Date();
  const yesterday = new Date();
  const tomorrow = new Date();

  yesterday.setDate(today.getDate() - 1);
  tomorrow.setDate(today.getDate() + 1);

  const isSameDay = (d1, d2) =>
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();

  if (isSameDay(inputDate, today)) return "Today";
  if (isSameDay(inputDate, tomorrow)) return "Tomorrow";
  if (isSameDay(inputDate, yesterday)) return "Yesterday";

  // Format as "29 Jul 2025"
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return inputDate.toLocaleDateString("en-GB", options);
}



export const positionStatusOptions = [
    {value: "All", label: "All"},
    {value: "Open", label: "Open"},
    {value: "Close", label: "Close"},
    { value: "On Hold", label:"On Hold"},
]

export const navList = [
    { name: "Home", path: "" },
    { name: "Daily Sourcing Update", path: "daily-sourcing-update" },
    { name: "ATS Pipeline", path: "ats-pipeline" },
    { name: "Tasks", path: "tasks" },
    { name: "Settings", path: "settings" },
    { name: "Profile", path: "profile" },
];
export const candidateStatusList = [
    { value: "Sent To Client", label: "Sent To Client" },
    { value: "CV On Hold", label: "CV On Hold" },
    { value: "CV Rejected", label: "CV Rejected" },
    { value: "Shortlisted", label: "Shortlisted" },
    { value: "Duplicate CV", label: "Duplicate CV" },
    { value: "Interview Scheduled", label: "Interview Scheduled" },
    { value: "Interview Feedback Pending", label: "Interview Feedback Pending" },
    { value: "Shortlisted Next Round", label: "Shortlisted Next Round" },
    { value: "Hold Post Interview", label: "Hold Post Interview" },
    { value: "Rejected Post Interview", label: "Rejected Post Interview" },
    { value: "Final Selection", label: "Final Selection" },
    { value: "Final Joining", label: "Final Joining" },
    { value: "Backout", label: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];
export const atsStatusList = [
    { value: "CV On Hold", label: "CV On Hold" },
    { name: "CV Rejected", value: "CV Rejected" },
    { name: "Shortlisted", value: "Shortlisted" },
    { name: "Duplicate CV", value: "Duplicate CV" },
    { name: "Interview Scheduled", value: "Interview Scheduled" },
    { name: "Interview Feedback Pending", value: "Interview Feedback Pending" },
    { name: "Shortlisted Next Round", value: "Shortlisted Next Round" },
    { name: "Interview Done", value: "Interview Done" },
    { name: "Hold Post Interview", value: "Hold Post Interview" },
    { name: "Rejected Post Interview", value: "Rejected Post Interview" },
    { name: "Final Selection", value: "Final Selection" },
    { name: "Final Joining", value: "Final Joining" },
    { name: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];

// ATS pipeline status
export const atsStatus1 = [
    { label: "Sent To Client", value: "Sent To Client", disable: true},
    { value: "CV On Hold", label: "CV On Hold" },
    { label: "CV Rejected", value: "CV Rejected" },
    { label: "Shortlisted", value: "Shortlisted" },
    { label: "Duplicate CV", value: "Duplicate CV" },
    { label: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];
export const atsStatus2 = [
    { label: "Shortlisted", value: "Shortlisted", disable: true},
    { label: "Interview Scheduled", value: "Interview Scheduled" },
    { label: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];
export const atsStatus3 = [
    { label: "Final Selection", value: "Final Selection", disable: true},
    { label: "Candidate Joined", value: "Final Joining" },
    { label: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];
export const atsStatus4 = [
    { label: "Final Joining", value: "Final Joining", disable: true},
    { label: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];

export const atsStatus5 = [
    { value: "CV On Hold", label: "CV On Hold", disable: true},
    { label: "CV Rejected", value: "CV Rejected" },
    { label: "Shortlisted", value: "Shortlisted" },
    { label: "Duplicate CV", value: "Duplicate CV" },
    { label: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];

export const allInterviewStatusOptions = [
    {label: "Interview Scheduled", value: "Interview Scheduled"},
    {label: "Interview Feedback Pending", value: "Interview Feedback Pending"},
    {label: "Shortlisted Next Round", value: "Shortlisted Next Round"},
    {label: "Rejected Post Interview", value: "Rejected Post Interview"},
    {label: "Hold Post Interview", value: "Hold Post Interview"},
    {label: "Backout", value: "Backout"},
    {label: "Final Selection", value: "Final Selection"},
    { value: "Blacklist", label: "Blacklist" },
];
export const interviewStatusOptions = [
    {label: "Interview Scheduled", value: "Interview Scheduled", disable: true},
    {label: "Interview Feedback Pending", value: "Interview Feedback Pending"},
    {label: "Shortlisted Next Round", value: "Shortlisted Next Round"},
    {label: "Rejected Post Interview", value: "Rejected Post Interview"},
    {label: "Hold Post Interview", value: "Hold Post Interview"},
    {label: "Backout", value: "Backout"},
    {label: "Final Selection", value: "Final Selection"},
    { value: "Blacklist", label: "Blacklist" },
];

export const atsStatusSentToClient = [
    { name: "CV Rejected", value: "CV Rejected" },
    { name: "Shortlisted", value: "Shortlisted" },
    { name: "Duplicate CV", value: "Duplicate CV" },
    { name: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];
export const atsStatusShortlisted = [
    // { name: "Shortlisted", value: "Shortlisted" },
    { name: "Interview Scheduled", value: "Interview Scheduled" },
    { name: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];
export const atsStatusFinalSelection = [
    // { name: "Final Selection", value: "Final Selection" },
    { name: "Candidate Joined", value: "Final Joining" },
    { name: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];
export const atsStatusFinalJoining = [
    // { name: "Final Joining", value: "Final Joining" },
    { name: "Backout", value: "Backout" },
    { value: "Blacklist", label: "Blacklist" },
];

// Interview schedule status
export const interviewStatusInterview = [
    { name: "Interview Feedback Pending", value: "Interview Feedback Pending" },
    { value: "Blacklist", label: "Blacklist" },
];
export const interviewInterviewFeedbackPending = [
    { name: "Shortlisted Next Round", value: "Shortlisted Next Round" },
    { name: "Rejected Post Interview", value: "Rejected Post Interview" },
    { name: "Hold Post Interview", value: "Hold Post Interview" },
    { name: "Backout", value: "Backout" },
    { name: "Final Selection", value: "Final Selection" },
    { value: "Blacklist", label: "Blacklist" },
];

export const monthData = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function validateFile(file, size = 2, allowedTypes = ['application/pdf']) {
    // Allowed file types (MIME types for PDF, DOC, DOCX)
    // const allowedTypes = [
    //     'application/pdf',
    //     'application/msword', 
    //     'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
    // ];

    // default size: 2MB (in bytes)
    const maxSize = size * 1024 * 1024;

    if (!file) {
        return { valid: false, message: 'No file selected.' };
    }

    // Check file type
    if (!allowedTypes.includes(file.type)) {
        return { valid: false, message: 'Invalid file type. Only PDF is allowed.' };
    }

    // Check file size
    if (file.size > maxSize) {
        return { valid: false, message: `File size exceeds ${size}MB limit.` };
    }

    return { valid: true, message: 'File is valid.' };
}

export const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);
 
export const validatePhoneNumber = (isoCode = "IN", phoneNumber)=> {
    // console.log("isoCode, phoneNumber",isoCode, phoneNumber);
    // Find the country object by isoCode
    const country = countryPhoneCode.find(item => item.isoCode === isoCode);

    if (!country) {
        return { isValid: false, codeError: true, message: "Invalid country code" };
    }

    // Remove any non-digit characters from phoneNumber
    const cleanedNumber = phoneNumber.replace(/\D/g, '');

    // Check length
    if (cleanedNumber.length !== country.phoneNumberLength) {
        return {
            isValid: false,
            codeError: false,
            message: `Phone number must be ${country.phoneNumberLength} digits for ${country.name}`
        };
    }

    return { isValid: true, message: "Valid phone number" };
}

export function isValidDateTillCurrent(inputDate) {
  // Check if inputDate is provided and is a valid Date object or string
  const date = new Date(inputDate);

  // If date is invalid, return false
  if (isNaN(date.getTime())) {
    return false;
  }

  // Get year from input
  const inputYear = date.getFullYear();

  // Get current year
  const currentYear = new Date().getFullYear();

  // Validate year (should not be greater than current year)
  if (inputYear > currentYear) {
    return false;
  }

  return true;
}

export function validateTime(value) {
  const result = {
    success: false,
    message: "",
  };

  if (!value) {
    result.message = "Time is required";
    return result;
  }

  // Regex to match 12-hour format with AM/PM
  const regex = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i;
  const match = value.match(regex);

  if (!match) {
    result.message = "Invalid format. Use HH:MM AM/PM (e.g. 03:00 PM)";
    return result;
  }

  const hour = parseInt(match[1], 10);
  const minute = parseInt(match[2], 10);

  if (hour < 1 || hour > 12) {
    result.message = "Hour must be between 1 and 12";
    return result;
  }

  if (minute < 0 || minute > 59) {
    result.message = "Minutes must be between 00 and 59";
    return result;
  }

  return {
    success: true,
    message: "Valid time",
  };
}


export const countryPhoneCode = [
    {
        name: "United States",
        isoCode: "US",
        phoneCode: "+1",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/us.svg"
    },
    {
        name: "Canada",
        isoCode: "CA",
        phoneCode: "+1",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/ca.svg"
    },
    {
        name: "United Kingdom",
        isoCode: "GB",
        phoneCode: "+44",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/gb.svg"
    },
    {
        name: "Australia",
        isoCode: "AU",
        phoneCode: "+61",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/au.svg"
    },
    {
        name: "India",
        isoCode: "IN",
        phoneCode: "+91",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/in.svg"
    },
    {
        name: "Malaysia",
        isoCode: "MY",
        phoneCode: "+60",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/my.svg"
    },
    {
        name: "Germany",
        isoCode: "DE",
        phoneCode: "+49",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/de.svg"
    },
    {
        name: "France",
        isoCode: "FR",
        phoneCode: "+33",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/fr.svg"
    },
    {
        name: "Japan",
        isoCode: "JP",
        phoneCode: "+81",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/jp.svg"
    },
    {
        name: "China",
        isoCode: "CN",
        phoneCode: "+86",
        phoneNumberLength: 11,
        flag: "https://flagcdn.com/cn.svg"
    },
    {
        name: "Brazil",
        isoCode: "BR",
        phoneCode: "+55",
        phoneNumberLength: 11,
        flag: "https://flagcdn.com/br.svg"
    },
    {
        name: "South Africa",
        isoCode: "ZA",
        phoneCode: "+27",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/za.svg"
    },
    {
        name: "Russia",
        isoCode: "RU",
        phoneCode: "+7",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/ru.svg"
    },
    {
        name: "Mexico",
        isoCode: "MX",
        phoneCode: "+52",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/mx.svg"
    },
    {
        name: "Italy",
        isoCode: "IT",
        phoneCode: "+39",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/it.svg"
    },
    {
        name: "Spain",
        isoCode: "ES",
        phoneCode: "+34",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/es.svg"
    },
    {
        name: "Bahrain",
        isoCode: "BH",
        phoneCode: "+973",
        phoneNumberLength: 8,
        flag: "https://flagcdn.com/bh.svg"
    },
    {
        name: "Iran",
        isoCode: "IR",
        phoneCode: "+98",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/ir.svg"
    },
    {
        name: "Iraq",
        isoCode: "IQ",
        phoneCode: "+964",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/iq.svg"
    },
    {
        name: "Israel",
        isoCode: "IL",
        phoneCode: "+972",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/il.svg"
    },
    {
        name: "Jordan",
        isoCode: "JO",
        phoneCode: "+962",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/jo.svg"
    },
    {
        name: "Kuwait",
        isoCode: "KW",
        phoneCode: "+965",
        phoneNumberLength: 8,
        flag: "https://flagcdn.com/kw.svg"
    },
    {
        name: "Lebanon",
        isoCode: "LB",
        phoneCode: "+961",
        phoneNumberLength: 8,
        flag: "https://flagcdn.com/lb.svg"
    },
    {
        name: "Oman",
        isoCode: "OM",
        phoneCode: "+968",
        phoneNumberLength: 8,
        flag: "https://flagcdn.com/om.svg"
    },
    {
        name: "Qatar",
        isoCode: "QA",
        phoneCode: "+974",
        phoneNumberLength: 8,
        flag: "https://flagcdn.com/qa.svg"
    },
    {
        name: "Saudi Arabia",
        isoCode: "SA",
        phoneCode: "+966",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/sa.svg"
    },
    {
        name: "Syria",
        isoCode: "SY",
        phoneCode: "+963",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/sy.svg"
    },
    {
        name: "Turkey",
        isoCode: "TR",
        phoneCode: "+90",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/tr.svg"
    },
    {
        name: "United Arab Emirates",
        isoCode: "AE",
        phoneCode: "+971",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/ae.svg"
    },
    {
        name: "Yemen",
        isoCode: "YE",
        phoneCode: "+967",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/ye.svg"
    },
    {
        name: "Nigeria",
        isoCode: "NG",
        phoneCode: "+234",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/ng.svg"
    },
    {
        name: "Zimbabwe",
        isoCode: "ZW",
        phoneCode: "+263",
        phoneNumberLength: 9,
        flag: "https://flagcdn.com/zw.svg"
    },
    {
        name: "Egypt",
        isoCode: "EG",
        phoneCode: "+20",
        phoneNumberLength: 10,
        flag: "https://flagcdn.com/eg.svg"
    }

];

export const currencyList = [
  {
    country: "Bahrain",
    label: "Bahrain",
    value: "BHD",
    code: "BHD",
    currency: "Dinar",
    symbol: "د.ب",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Flag_of_Bahrain.svg/32px-Flag_of_Bahrain.svg.png"
  },
  {
    country: "European Union",
    label: "European Union",
    value: "EUR",
    code: "EUR",
    currency: "Euro",
    symbol: "€",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Flag_of_Europe.svg/32px-Flag_of_Europe.svg.png"
  },
  {
    country: "India",
    label: "India",
    value: "INR",
    code: "INR",
    currency: "Rupee",
    symbol: "₹",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Flag_of_India.svg/32px-Flag_of_India.svg.png"
  },
  {
    country: "Kuwait",
    label: "Kuwait",
    value: "KWD",
    code: "KWD",
    currency: "Dinar",
    symbol: "د.ك",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Flag_of_Kuwait.svg/32px-Flag_of_Kuwait.svg.png"
  },
  {
    country: "Oman",
    label: "Oman",
    value: "OMR",
    code: "OMR",
    currency: "Rial",
    symbol: "ر.ع",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Flag_of_Oman.svg/32px-Flag_of_Oman.svg.png"
  },
  {
    country: "Qatar",
    label: "Qatar",
    value: "QAR",
    code: "QAR",
    currency: "Riyal",
    symbol: "ر.ق",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Flag_of_Qatar.svg/32px-Flag_of_Qatar.svg.png"
  },
  {
    country: "Saudi Arabia",
    label: "Saudi Arabia",
    value: "SAR",
    code: "SAR",
    currency: "Riyal",
    symbol: "ر.س",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Flag_of_Saudi_Arabia.svg/32px-Flag_of_Saudi_Arabia.svg.png"
  },
  {
    country: "United Arab Emirates",
    label: "United Arab Emirates",
    value: "AED",
    code: "AED",
    currency: "Dirham",
    symbol: "د.إ",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Flag_of_the_United_Arab_Emirates.svg/32px-Flag_of_the_United_Arab_Emirates.svg.png"
  },
  {
    country: "United States",
    label: "United States",
    value: "USD",
    code: "USD",
    currency: "Dollar",
    symbol: "$",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Flag_of_the_United_States.svg/32px-Flag_of_the_United_States.svg.png"
  },
  {
    country: "Egypt",
    label: "Egypt",
    value: "EGP",
    code: "EGP",
    currency: "Egyptian Pound",
    symbol: "E£",
    img: "https://flagcdn.com/w40/eg.png"
  }
];





export const homeTableHeading = [
    "Company",
    "Position",
    "Location",
    "Openings",
    "CTC",
    "Date"
]
export const industryList = [
    "Accounting / Auditing",
    "Advertising & Marketing",
    "Agriculture / Forestry / Fishing",
    "Analytics / KPO / Research",
    "Animation & VFX",
    "Architecture / Interior Design",
    "Auto Components",
    "Automobile",
    "Aviation",
    "BPO / Call Centre",
    "Banking",
    "Beauty & Personal Care",
    "Beverage",
    "Biotechnology",
    "Building Material",
    "Chemicals",
    "Clinical Research / Contract Research",
    "Consumer Electronics & Appliances",
    "Content Development / Language",
    "Courier / Logistics",
    "Defence & Aerospace",
    "Design",
    "E-Learning / EdTech",
    "Education / Training",
    "Electrical Equipment",
    "Electronic Components / Semiconductors",
    "Electronics Manufacturing",
    "Emerging Technologies",
    "Engineering & Construction",
    "Events / Live Entertainment",
    "FMCG",
    "Facility Management Services",
    "Fertilizers / Pesticides / Agro chemicals",
    "Film / Music / Entertainment",
    "FinTech / Payments",
    "Financial Services",
    "Fitness & Wellness",
    "Food Processing",
    "Furniture & Furnishing",
    "Gaming",
    "Gems & Jewellery",
    "Government / Public Administration",
    "Hardware & Networking",
    "Hotels & Restaurants",
    "IT Services & Consulting",
    "Import & Export",
    "Industrial Automation",
    "Industrial Equipment / Machinery",
    "Insurance",
    "Internet",
    "Investment Banking / Venture Capital / Private Equity",
    "Iron & Steel",
    "Law Enforcement / Security Services",
    "Leather",
    "Legal",
    "Manufacturing",
    "Management Consulting",
    "Medical Devices & Equipment",
    "Medical Services / Hospital",
    "Metals & Mining",
    "Miscellaneous",
    "NBFC",
    "NGO / Social Services / Industry Associations",
    "Oil & Gas",
    "Packaging & Containers",
    "Petrochemical / Plastics / Rubber",
    "Pharmaceutical & Life Sciences",
    "Ports & Shipping",
    "Power",
    "Printing & Publishing",
    "Pulp & Paper",
    "Railways",
    "Real Estate",
    "Recruitment / Staffing",
    "Retail",
    "Software Product",
    "Sports / Leisure & Recreation",
    "TV / Radio",
    "Telecom / ISP",
    "Textile & Apparel",
    "Travel & Tourism",
    "Urban Transport",
    "Water Treatment / Waste Management"
];
export const industryOptions = [
    {value: "Accounting / Auditing" ,label:"Accounting / Auditing"},
    {value: "Advertising & Marketing" ,label:"Advertising & Marketing"},
    {value: "Agriculture / Forestry / Fishing" ,label:"Agriculture / Forestry / Fishing"},
    {value: "Analytics / KPO / Research" ,label:"Analytics / KPO / Research"},
    {value: "Animation & VFX" ,label:"Animation & VFX"},
    {value: "Architecture / Interior Design" ,label:"Architecture / Interior Design"},
    {value: "Auto Components" ,label:"Auto Components"},
    {value: "Automobile" ,label:"Automobile"},
    {value: "Aviation" ,label:"Aviation"},
    {value: "BPO / Call Centre" ,label:"BPO / Call Centre"},
    {value: "Banking" ,label:"Banking"},
    {value: "Beauty & Personal Care" ,label:"Beauty & Personal Care"},
    {value: "Beverage" ,label:"Beverage"},
    {value: "Biotechnology" ,label:"Biotechnology"},
    {value: "Building Material" ,label:"Building Material"},
    {value: "Chemicals" ,label:"Chemicals"},
    {value: "Clinical Research / Contract Research" ,label:"Clinical Research / Contract Research"},
    {value: "Consumer Electronics & Appliances" ,label:"Consumer Electronics & Appliances"},
    {value: "Content Development / Language" ,label:"Content Development / Language"},
    {value: "Courier / Logistics" ,label:"Courier / Logistics"},
    {value: "Defence & Aerospace" ,label:"Defence & Aerospace"},
    {value: "Design" ,label:"Design"},
    {value: "E-Learning / EdTech" ,label:"E-Learning / EdTech"},
    {value: "Education / Training" ,label:"Education / Training"},
    {value: "Electrical Equipment" ,label:"Electrical Equipment"},
    {value: "Electronic Components / Semiconductors" ,label:"Electronic Components / Semiconductors"},
    {value: "Electronics Manufacturing" ,label:"Electronics Manufacturing"},
    {value: "Emerging Technologies" ,label:"Emerging Technologies"},
    {value: "Engineering & Construction" ,label:"Engineering & Construction"},
    {value: "Events / Live Entertainment" ,label:"Events / Live Entertainment"},
    {value: "FMCG" ,label:"FMCG"},
    {value: "Facility Management Services" ,label:"Facility Management Services"},
    {value: "Fertilizers / Pesticides / Agro chemicals" ,label:"Fertilizers / Pesticides / Agro chemicals"},
    {value: "Film / Music / Entertainment" ,label:"Film / Music / Entertainment"},
    {value: "FinTech / Payments" ,label:"FinTech / Payments"},
    {value: "Financial Services" ,label:"Financial Services"},
    {value: "Fitness & Wellness" ,label:"Fitness & Wellness"},
    {value: "Food Processing" ,label:"Food Processing"},
    {value: "Furniture & Furnishing" ,label:"Furniture & Furnishing"},
    {value: "Gaming" ,label:"Gaming"},
    {value: "Gems & Jewellery" ,label:"Gems & Jewellery"},
    {value: "Government / Public Administration" ,label:"Government / Public Administration"},
    {value: "Hardware & Networking" ,label:"Hardware & Networking"},
    {value: "Hotels & Restaurants" ,label:"Hotels & Restaurants"},
    {value: "IT Services & Consulting" ,label:"IT Services & Consulting"},
    {value: "Import & Export" ,label:"Import & Export"},
    {value: "Industrial Automation" ,label:"Industrial Automation"},
    {value: "Industrial Equipment / Machinery" ,label:"Industrial Equipment / Machinery"},
    {value: "Insurance" ,label:"Insurance"},
    {value: "Internet" ,label:"Internet"},
    {value: "Investment Banking / Venture Capital / Private Equity" ,label:"Investment Banking / Venture Capital / Private Equity"},
    {value: "Iron & Steel" ,label:"Iron & Steel"},
    {value: "Law Enforcement / Security Services" ,label:"Law Enforcement / Security Services"},
    {value: "Leather" ,label:"Leather"},
    {value: "Legal" ,label:"Legal"},
    {value: "Manufacturing" ,label:"Manufacturing"},
    {value: "Management Consulting" ,label:"Management Consulting"},
    {value: "Medical Devices & Equipment" ,label:"Medical Devices & Equipment"},
    {value: "Medical Services / Hospital" ,label:"Medical Services / Hospital"},
    {value: "Metals & Mining" ,label:"Metals & Mining"},
    {value: "Miscellaneous" ,label:"Miscellaneous"},
    {value: "NBFC" ,label:"NBFC"},
    {value: "NGO / Social Services / Industry Associations" ,label:"NGO / Social Services / Industry Associations"},
    {value: "Oil & Gas" ,label:"Oil & Gas"},
    {value: "Packaging & Containers" ,label:"Packaging & Containers"},
    {value: "Petrochemical / Plastics / Rubber" ,label:"Petrochemical / Plastics / Rubber"},
    {value: "Pharmaceutical & Life Sciences" ,label:"Pharmaceutical & Life Sciences"},
    {value: "Ports & Shipping" ,label:"Ports & Shipping"},
    {value: "Power" ,label:"Power"},
    {value: "Printing & Publishing" ,label:"Printing & Publishing"},
    {value: "Pulp & Paper" ,label:"Pulp & Paper"},
    {value: "Railways" ,label:"Railways"},
    {value: "Real Estate" ,label:"Real Estate"},
    {value: "Recruitment / Staffing" ,label:"Recruitment / Staffing"},
    {value: "Retail" ,label:"Retail"},
    {value: "Software Product" ,label:"Software Product"},
    {value: "Sports / Leisure & Recreation" ,label:"Sports / Leisure & Recreation"},
    {value: "TV / Radio" ,label:"TV / Radio"},
    {value: "Telecom / ISP" ,label:"Telecom / ISP"},
    {value: "Textile & Apparel" ,label:"Textile & Apparel"},
    {value: "Travel & Tourism" ,label:"Travel & Tourism"},
    {value: "Urban Transport" ,label:"Urban Transport"},
    {value: "Water Treatment / Waste Management" ,label:"Water Treatment / Waste Management"},
    {value: "other" ,label:"Other"},
];


export const getGreeting = (date = new Date())=> {
  const hour = date.getHours(); // 0–23 in the user’s local time

  if (hour >= 5 && hour < 12) {
    return "Good morning";
  }
  if (hour >= 12 && hour < 17) {
    return "Good afternoon";
  }
  if (hour >= 17 && hour < 21) {
    return "Good evening";
  }
  return "Have a good day"; // night hours (21:00–04:59); change to "Good night" if you prefer
}
// export const sourceReportData=[]

export function parseQueryString(queryString) {
    const params = {};
    queryString.split('&').forEach(param => {
        const [key, value] = param.split('=');
        params[key] = value;
    });
    return params;
}

export function validateNumber(value, max = null) {
  const result = {
    success: false,
    message: "",
  };

  const regex = /^(0|[1-9]\d*)(\.\d{1,2})?$/;

  if (!regex.test(value)) {
    result.message = "Only valid numbers are allowed (e.g. 4 or 4.45)";
    return result;
  }

  const num = parseFloat(value);
  if (isNaN(num)) {
    result.message = "Invalid number format";
    return result;
  }

  if (max !== null && num > max) {
    result.message = `Value must be less than or equal to ${max}`;
    return result;
  }
  return {
    success: true,
    message: "Valid number",
  };
}

export const monthList = [
    {value: '01', label:`Jan ${new Date().getFullYear()}`},
    {value: '02', label:`Feb ${new Date().getFullYear()}`},
    {value: '03', label:`Mar ${new Date().getFullYear()}`},
    {value: '04', label:`Apr ${new Date().getFullYear()}`},
    {value: '05', label:`May ${new Date().getFullYear()}`},
    {value: '06', label:`Jun ${new Date().getFullYear()}`},    
    {value: '07', label:`Jul ${new Date().getFullYear()}`},
    {value: '08', label:`Aug ${new Date().getFullYear()}`},
    {value: '09', label:`Sep ${new Date().getFullYear()}`},
    {value: '10', label:`Oct ${new Date().getFullYear()}`},
    {value: '11', label:`Nov ${new Date().getFullYear()}`},
    {value: '12', label:`Dec ${new Date().getFullYear()}`},
  ];
